module.exports = __webpack_public_path__ + "media/images/banner/tjt/sp/travel202309_03_1280_1280_zh-hant-a8e005167b79020b1d98cae11d4db003.jpg";